import { render, staticRenderFns } from "./margin-settings.vue?vue&type=template&id=e937dfbc&scoped=true&"
import script from "./margin-settings.vue?vue&type=script&lang=js&"
export * from "./margin-settings.vue?vue&type=script&lang=js&"
import style0 from "./margin-settings.vue?vue&type=style&index=0&id=e937dfbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e937dfbc",
  null
  
)

export default component.exports